import { Trans, useTranslation } from "react-i18next";
import { FCC } from "types";

import { LandingBlob } from "@/components/Welcome/LandingBlob/LandingBlob";

import { LoginButton } from "./LoginButton";

export const WelcomeContent: FCC = () => {
  const { t } = useTranslation();

  return (
    <LandingBlob>
      <div id="text-and-buttons" className="mb-10">
        <h1 className="md:hero mb-6 max-w-min text-secondary-100 md:mb-8 md:max-w-full">
          {t("Content.headline")}
        </h1>

        <div className="mb-10 max-w-[600px] md:mb-14">
          <p className="mb-4">
            <Trans
              t={t}
              i18nKey="Content.welcomeText"
              components={[
                <a
                  key="ratesLink"
                  href={t("Content.ratesLink")}
                  className="font-semibold text-secondary-100 underline"
                  target="_blank"
                  rel="noreferrer"
                />,
              ]}
            />
          </p>

          <p>{t("Content.welcomeTextEsimUpsell")}</p>
        </div>

        <div className="flex flex-col gap-4 md:w-auto md:flex-row md:gap-6">
          <LoginButton />
        </div>
      </div>

      <div id="shop-link" className="flex flex-wrap text-base">
        <span className="mr-4 whitespace-nowrap">{t("Content.products")}</span>
        <a
          href={t("Content.shopLink")}
          className="whitespace-nowrap font-semibold text-secondary-100 hover:underline"
          target="_blank"
          rel="noreferrer"
        >
          {t("Content.shop")}
        </a>
      </div>
    </LandingBlob>
  );
};
